// src/features/userUsageTracker/userUsageTrackerSlice.js
import {createSlice} from '@reduxjs/toolkit';
import {captureActivity, getUserUsage} from './userUsageTrackerActions';

/* ------------------------------------------------------------------ */
/* Initial shape keeps every request distinct to simplify UI logic    */
/* ------------------------------------------------------------------ */
const initialState = {
    usageData: [],         // result of getUserUsage
    captureStatus: null,   // success/error status for captureActivity
    loading: false,
    error: null,
};

const userUsageTrackerSlice = createSlice({
    name: 'userUsageTracker',
    initialState,
    reducers: {
        resetUsageTrackerState: () => initialState,     // optional helper
        clearCaptureStatus: (state) => {
            state.captureStatus = null;
        },
    },
    extraReducers: builder => {
        /* ---------- Shared pending / rejected helpers ---------- */
        const setPending = state => {
            state.loading = true;
            state.error = null;
        };
        const setRejected = (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Unknown error';
        };

        /* ---------- captureActivity ---------- */
        builder
            .addCase(captureActivity.pending, setPending)
            .addCase(captureActivity.fulfilled, (state, action) => {
                state.loading = false;
                state.captureStatus = 'success';
            })
            .addCase(captureActivity.rejected, setRejected);

        /* ---------- getUserUsage ---------- */
        builder
            .addCase(getUserUsage.pending, setPending)
            .addCase(getUserUsage.fulfilled, (state, action) => {
                state.loading = false;
                state.usageData = action.payload.usage || [];
            })
            .addCase(getUserUsage.rejected, setRejected);
    },
});

export const {resetUsageTrackerState, clearCaptureStatus} = userUsageTrackerSlice.actions;
export default userUsageTrackerSlice.reducer;

/* ------------------------------------------------------------------ */
/* Optional Selectors – keeps components clean                         */
/* ------------------------------------------------------------------ */
export const selectUsageData = state => state.userUsageTracker.usageData;
export const selectUsageTrackerLoading = state => state.userUsageTracker.loading;
export const selectUsageTrackerError = state => state.userUsageTracker.error;
export const selectCaptureStatus = state => state.userUsageTracker.captureStatus;